import { useSelector } from 'react-redux';
import { isMultiDayVisitsMetadataEnabledSelector } from 'store/ui-metadata/selectors';

export const useMultiDayVisitsEnabled = (): boolean => {
  return useSelector(isMultiDayVisitsMetadataEnabledSelector);
};
